import React from 'react'
import { Logo } from '../Logo';

export const Preloader = ({fullscreen, text="Так-так, что тут у нас..."}) => {

  const style = fullscreen ? {height: '100vh'} : {};

    return (
        <div className='preloader dark-theme-bg0' style={style}>
                <Logo showName={false} height={96} />
                <h2>{text}</h2>
        </div>
    );
}
